import MobxTextArea from './MobxTextArea'

export default MobxTextArea
